<template>
    <div class="apprentice-simple-card">
        <p class="description">{{ $t('internship.add_your_internship_function') }}</p>
        <div class="row">
            <div class="col-12 col-md-8 col-xl-6">
                <div class="external-internship-create">
                    <div
                        class="internship-banner-preview"
                        v-if="banner_preview !== ''">
                        <b-img :src="banner_preview"></b-img>
                    </div>
                    <b-alert
                        variant="warning"
                        show
                        >{{ $t('common.all_fields_are_mandatory') }}</b-alert
                    >
                    <b-form-group
                        class="internship-name"
                        label-for="internship-name-input"
                        :label="$t('common.name')">
                        <b-form-input
                            id="internship-name-input"
                            v-model="name"
                            placeholder="Functie titel">
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        class="internship-location"
                        label-for="internship-location-input"
                        :label="$t('common.location')">
                        <b-form-input
                            id="internship-location-input"
                            v-model="location"
                            :placeholder="$t('common.location')">
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        class="internship-slots"
                        label-for="internship-slots"
                        :label="$t('internship.amount_of_places')">
                        <b-form-input
                            id="internship-slots"
                            v-model="slots"
                            :placeholder="$t('internship.amount_of_places')"
                            type="number">
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        class="internship-tags"
                        label-for="internship-tags-input"
                        label="labels">
                        <design-2021-apprentice-multiselect-component
                            v-model="tags"
                            label="name"
                            :options="internshipTagsIn"
                            track-by="id">
                        </design-2021-apprentice-multiselect-component>
                    </b-form-group>

                    <b-form-group
                        class="group-input-file"
                        :label="$t('internship.image')"
                        label-for="internship-banner-input">
                        <b-form-file
                            class="apprentice-file-upload internship-banner-upload"
                            id="internship-banner-input"
                            v-model="file"
                            accept="image/jpeg,image/png"
                            :placeholder="$t('internship.upload_banner')"
                            @change="showPreview"></b-form-file>
                    </b-form-group>

                    <b-form-group
                        class="internship-description"
                        label-for="internship-description-input"
                        :label="$t('common.description')">
                        <b-form-textarea
                            class="apprentice-textarea"
                            id="internship-description-input"
                            v-model="description"
                            :placeholder="$t('common.description')"
                            rows="3"
                            max-rows="6">
                        </b-form-textarea>
                    </b-form-group>

                    <b-button
                        class="btn-save btn-save-school-settings"
                        variant="primary"
                        @click="save()">
                        {{ $t('common.save') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-external-organization-internships-create-component',
    props: ['internshipTagsIn'],
    data() {
        return {
            name: '',
            description: '',
            location: '',
            slots: null,
            tags: [],
            file: null,
            banner_preview: '',
        };
    },
    methods: {
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },
        save() {
            const tagIds = this.tags.map((tag) => tag.id);
            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('location', this.location);
            formData.append('slots', this.slots);
            if (this.file) {
                formData.append('file', this.file);
            }
            for (let i = 0; i < tagIds.length; i++) {
                formData.append('tags[' + i + ']', tagIds[i]);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            axios
                .post(this.routes.externalInternship(), formData, { headers: headers })
                .then((response) => {
                    window.location.href = this.routes.externalInternship();
                })
                .catch(function (error) {});
        },
    },
};
</script>

<style scoped lang="scss">
.external-internship-create {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    input,
    select,
    textarea {
        margin-bottom: 0;
    }

    .internship-banner-upload ::v-deep {
        height: 51px;

        label {
            margin-bottom: 0;
        }

        .form-file-text {
            color: $text-muted-color;
        }
    }

    .btn-save-school-settings {
        align-self: flex-end;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.internship-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}
</style>
